var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-box"},[_c('img',{staticClass:"join_top",attrs:{"src":_vm.IMG+'/img_page.png'}}),_vm._v(" "),_c('img',{staticClass:"join_bt",attrs:{"src":_vm.IMG+'/hezuo_bt.png'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8a4db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/joinUs.vue
// module id = null
// module chunks = 